import * as d3 from 'd3';
import { NeedleFormat } from './NeedleFormat';

export function renderNeedle(selection: d3.selection.Update<{ needle: NeedleFormat }>) {
    const ratio = 10;
    const dataBound = selection
        .selectAll('.needle')
        .data(d => [d.needle]);
    dataBound.exit()
        .remove();
    const enterNeedle = dataBound.enter()
        .append('g')
        .classed('needle', true);
    enterNeedle.append('path');
    dataBound.select('path')
        .attr('d', d => {
            const size = d.size;
            const h = size / ratio;
            return `M -${h / 2} ${0} H ${h} L ${h / 2} -${size}`;
        })
        .attr('transform', d => `translate(${-d.position + d.size}, ${d.size / ratio / 2}) rotate(-90)`);
    dataBound
        .transition()
        .attr('transform', d => {
            return `rotate(${d.rotation})`;
        });
}
